<template>
  <div class="container">
    <div class="row">
      <div class="col-auto">
        <input
          class="form-control"
          style="width: auto; display:initial; visibility: hidden;"
          placeholder="Search Keyword"
        />
      </div>
      <div class="col">
        <h3>Frequently Asked Questions</h3>
      </div>
      <div class="col-auto text-right">
        <input
          v-model="searchKeyword"
          class="form-control"
          style="width: auto; display:initial;"
          placeholder="Search Keyword"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <div
          v-for="(faq, index) in filterFAQs(faqs)"
          :key="faq.FAQ_Id"
          class="text-justify px-2 py-2"
          v-bind:class="{ 'light-background': index % 2 === 1 }"
        >
          <p class="mb-1">
            <b>
              {{ faq.Question }}
            </b>
          </p>
          <p>- {{ faq.Answer }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FAQ",
  data() {
    return {
      faqs: [],
      searchKeyword: ""
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    try {
      view.$data.faqs = await view.$getFAQs();
      view.$store.commit("updateLoading", false);
    } catch (err) {
      console.log(err);
      view.$store.commit("updateLoading", false);
    }
  },
  methods: {
    filterFAQs(faqs) {
      if (this.searchKeyword != "") {
        var lowerKeyword = this.searchKeyword.toLowerCase();
        return faqs.filter(
          f =>
            f.Question.toLowerCase().includes(lowerKeyword) ||
            f.Answer.toLowerCase().includes(lowerKeyword)
        );
      } else {
        return faqs;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
